import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Layout } from "@/components/Layout";
import { renderBlocks } from "@/components/Blocks";
import { trackEvent } from "@/lib/analytics";

export default function LandingPage({ page }) {
  useEffect(() => {
    if (page.path === "/cenik") trackEvent("view_pricing", { page: page.path });
    if (page.path === "/mission-jested") trackEvent("view_mission_jested", { page: page.path });
    window.scrollTo(0, 0);
  }, [page.path]);

  return (
    <Layout breadcrumbs={page.breadcrumbs}>
      <Seo page={page} />
      {renderBlocks(page.blocks, page.related)}
    </Layout>
  );
}
